import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {addNewsApi, editNews} from '../api/news';
import {uplodeImage} from '../api/util';
import swal from "sweetalert2";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit,OnChanges {

  constructor(private _fb: FormBuilder) { }
  @ViewChild('textarea')textarea: ElementRef;

  @Input('selectedRow')selectedRow={}
  @Input('editMode')editMode=false
  imageUplode=false
  @Output() refresh = new EventEmitter();
  data: FormGroup;
  profileImg="../../assets/images/newsHolder.jpeg"


  ngOnInit() {
    this.data = this._fb.group({
      title: ['',Validators.required],
      description: ['',Validators.required],
      img: ['',Validators.required],
      created_by:null
    });
  this.textarea.nativeElement.value = '';
  }
  openFile() {
    document.getElementById('file').click();

  }
  changeImage(input) {
    console.log('sss', input);
    let reader;
    if (input.target.files) {
      reader = new FileReader();

      reader.onload = (e) => {
        console.log(e.target.result);
        this.imageUplode=true

        this.data.get('img').setValue(e.target.result);
        this.profileImg=e.target.result
        // preview.setAttribute('src', e.target.result);
      }

      reader.readAsDataURL(input.target.files[0]);
    }
  }


  id=null
  async edit() {
    let data=this.data.value
    if (this.imageUplode) {
      const img = data.img;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.img = uplode.data;
      }
    }
    let result=editNews(data,this.id)
    if(result){
      this.data = this._fb.group({
        title: ['',Validators.required],
        description: ['',Validators.required],
        img: ['',Validators.required],
        created_by:null
      });
      this.profileImg="../../assets/images/newsHolder.jpeg"

      this.refresh.emit('refresh')
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }

  }

  async add() {
    let data=this.data.value
    if (this.imageUplode) {
      const img = data.img;
      const uplode = await uplodeImage(img);
      if (uplode) {
        this.data = this._fb.group({
          title: ['',Validators.required],
          description: ['',Validators.required],
          img: ['',Validators.required],
          created_by:null
        });
        data.img = uplode.data;
      }
    }
   let result= await addNewsApi(data)
if(result){
  this.data = this._fb.group({
    title: ['',Validators.required],
    description: ['',Validators.required],
    img: ['',Validators.required],
    created_by:null
  });
  this.profileImg="../../assets/images/newsHolder.jpeg"

  this.refresh.emit('refresh')
}else {
  swal(
    'حصل خطأ، يرجى المحاولة مرة أخرى',
    '',

    'error'
  )
}

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    if(changes.selectedRow&&changes.selectedRow.currentValue){
      let row=changes.selectedRow.currentValue
      this.data=this._fb.group({
        title:[row.title,Validators.required],
        description:[row.description,Validators.required],
        img:[row.img,Validators.required]
      })
      this.id=row._id
      this.profileImg=!row.img?"../../assets/images/newsHolder.jpeg":row.img

      this.editMode=changes.editMode.currentValue
    }

  }
}
